export interface SortingOption {
  id: string;
  name: string;
  orderBy: 'created' | 'price' | 'rent' | 'livingArea' | 'totalArea' | 'siteArea';
  order: 'asc' | 'desc';
  orderGroup?: string;
}

/**
 * Sorting options and their corresponding
 * ids and asc/desc information
 */
export default {
  options: [
    {
      id: 'newest',
      name: 'Uusin ilmoitus',
      orderBy: 'created',
      order: 'desc',
    },
    {
      id: 'oldest',
      name: 'Vanhin ilmoitus',
      orderBy: 'created',
      order: 'asc',
    },
    {
      id: 'lowestPrice',
      name: 'Halvin ensin',
      orderBy: 'price',
      order: 'asc',
      orderGroup: 'pricing',
    },
    {
      id: 'highestPrice',
      name: 'Kallein ensin',
      orderBy: 'price',
      order: 'desc',
      orderGroup: 'pricing',
    },
    {
      id: 'lowestRent',
      name: 'Halvin ensin',
      orderBy: 'rent',
      order: 'asc',
      orderGroup: 'pricing',
    },
    {
      id: 'highestRent',
      name: 'Kallein ensin',
      orderBy: 'rent',
      order: 'desc',
      orderGroup: 'pricing',
    },
    {
      id: 'smallestLivingArea',
      name: 'Pienin ensin',
      orderBy: 'livingArea',
      order: 'asc',
      orderGroup: 'area',
    },
    {
      id: 'largestLivingArea',
      name: 'Suurin ensin',
      orderBy: 'livingArea',
      order: 'desc',
      orderGroup: 'area',
    },
    {
      id: 'smallestTotalArea',
      name: 'Pienin ensin',
      orderBy: 'totalArea',
      order: 'asc',
      orderGroup: 'area',
    },
    {
      id: 'largestTotalArea',
      name: 'Suurin ensin',
      orderBy: 'totalArea',
      order: 'desc',
      orderGroup: 'area',
    },
    {
      id: 'smallestSiteArea',
      name: 'Pienin ensin',
      orderBy: 'siteArea',
      order: 'asc',
      orderGroup: 'area',
    },
    {
      id: 'largestSiteArea',
      name: 'Suurin ensin',
      orderBy: 'siteArea',
      order: 'desc',
      orderGroup: 'area',
    },
  ] as SortingOption[],
};
